<template>
  <InputPassword v-bind="$attrs" />
</template>

<script lang="tsx" setup name="SmartPassword">
import { InputPassword } from 'ant-design-vue'
</script>
